import React, { useState } from 'react'
import ReactTooltip from 'react-tooltip'
import styled from '@emotion/styled'

import PlayPauseButton from './PlayPauseButton'
import TriggerEvent from './TriggerEvent'
import ComposeInput from './ComposeInput'
import EmojiPicker from './EmojiPicker'
import SendButton from './SendButton'

const Wrapper = styled.div`
  width: 100%;
  padding: 10px 35px;
  margin-top: auto;
`

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  
  padding: 8px 8px 4px 8px;
  background-color: #EEF1F2;
  border-radius: 6px;
  
  user-select: none;
`

const Tooltip = styled(ReactTooltip)`
  color: #FFFFFF;
  background-color: #353A52;
  //border: 1px solid #90A1B0;
  box-shadow: 0 4px 16px rgba(53, 58, 82, 0.08);
  padding: 8px 16px;
  font-size: 12rem;
  font-family: inherit;
`

const Compose = () => {
  const [message, setMessage] = useState('')
  return(
    <Wrapper>
      <Block>
        <PlayPauseButton data-for="composeTooltip" />
        <TriggerEvent data-for="composeTooltip" data-tip="Trigger event" />
        <ComposeInput setMessage={setMessage} message={message} />
        <EmojiPicker setMessage={setMessage} />
        <SendButton  setMessage={setMessage} message={message} />
        <Tooltip id="composeTooltip" place="top" effect="solid" delayShow={400} />
      </Block>
    </Wrapper>
  )
}

export default Compose
